import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { TopicCreateForm } from "./components/TopicCreateForm";

export function NewTopicPage() {
  return (
    <LqsPage title="New Topic">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <TopicCreateForm />
      </Container>
    </LqsPage>
  );
}
